var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonPrevius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f6f3f2;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #002860;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button-previus",
    transform: "translate(-14731.83 23972.83) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    className: "cls-1",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(-23972.83 -14781.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    className: "cls-2",
    d: "M0,14.317V0H14.318",
    transform: "translate(-23948.053 -14749.445) rotate(-135)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPrevius);
export default __webpack_public_path__ + "static/media/Button-previus.9fbcc9bd2bb6c3ff0ce5d2b3491c47fb.svg";
export { ForwardRef as ReactComponent };